<div [ngClass]="CRMPartnerID==371?'bg-primary':'bg-dark'">
    <div class="mt--30">
        <div class="container">
            <div class="col-12 mb-3 text-white pt-5">
                <p class="fs-1 fw-bold">
                    Congratulations! You've made it this far.
                </p>
                <p class="fs-1 fw-bold">
                    You're just steps away from securing your next service with ZERO labour charges - you only pay for parts!
                    Bookings are open from 10h00 on Wednesday, 2nd July to 10h00 Friday, 4th July 2025.
                    Don't miss out - you're this close to major savings!
                </p>
                <div class="text-center py-5"><a class="btn btn-light rounded-pill fs-1 fw-bold px-5" style="color:rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;" href="/servicecampaign">Book Now</a></div>
            </div>
        </div>
        <app-slider [images]="banners"></app-slider>
    </div>
</div>